import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {RedirectService} from './redirect.service';
import {ErrorService} from './error.service';
import {StaticResourcesService} from "./static-resources.service";

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(
    private router: Router,
    private redirectService: RedirectService,
    private errorService: ErrorService,
    private staticResourcesService: StaticResourcesService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req)
      .pipe(
        catchError(
          err =>
            new Observable<HttpEvent<any>>(observer => {
              if (err instanceof HttpErrorResponse) {
                const errResp = <HttpErrorResponse>err;
                if (!errResp.ok) {
                  if (errResp.status === 200) {
                    console.log(errResp);
                  }
                  if (errResp.status === 403) {
                    if (req.url.endsWith("identity")) {
                      const key = 'AUTHENTICATORS.FORBIDDEN_ACCESS';
                      console.log(errResp);
                      if (this.router.url.includes("home")) {
                        this.errorService.showErrorAlertAndNavigate(key, ['home']);
                      } else {
                        this.errorService.goToErrorPage(key, 403);
                      }
                    } else {
                      const key = 'AUTHENTICATORS.FORBIDDEN_OPERATION';
                      this.errorService.showErrorAlert(key);
                    }
                  } else if (errResp.status === 401) {
                    this.redirectToSamlLogin();
                  } else if (errResp.status === 410) {
                    this.redirectService.redirectToSAMLLogout();
                  } else if (errResp.status === 500) {
                    this.errorService.goToErrorPage(errResp.error.error?.errorDescription, errResp.error.error?.errorCode);
                  }
                }
              }
              observer.error(err);
              observer.complete();
            })
        )
      )
      .pipe(
        tap(event => {

          if (req.url.includes("applications")) {
            this.staticResourcesService.fetchConfigs()
              .subscribe(
                config => {
                  let showApplications = config?.showApplications;
                  if (!showApplications) {
                    this.router.navigate(['authenticators']);
                  }
                });
          }
          if (event.type === HttpEventType.Response) {
          }
        }));
  }

  redirectToSamlLogin(): void {
    if (!this.router.url.includes("enrollment") && !this.router.url.includes("home")) {
      this.redirectService.redirectToSAMLLogin();
    }
  }
}
